export const tabsNames = {
	summary: 'Summary',
	attributes: 'Attributes',
	outgoingRequests: 'Outgoing requests',
	incomingRequests: 'Incoming requests',
	telecomSites: 'Telecom Sites',
};

export const tabs = [
	{
		title: tabsNames.summary,
		value: tabsNames.summary,
		iconName: 'summaryIcon',
		isVisible: true,
	},
	{
		title: tabsNames.attributes,
		value: tabsNames.attributes,
		iconName: 'attributesIcon',
		isVisible: true,
	},
];

interface IGetAssetProfileTabs {
	isIncomingRequestsTabShown: boolean;
	isIncomingRequestsEmpty: boolean;
	isOutgoingRequestsTabShown: boolean;
	isTelecomSitesTabShown: boolean;
}

export const getAssetProfileTabs = ({
	isIncomingRequestsTabShown,
	isIncomingRequestsEmpty,
	isOutgoingRequestsTabShown,
	isTelecomSitesTabShown,
}: IGetAssetProfileTabs) => {
	return [
		...tabs,
		{
			title: tabsNames.incomingRequests,
			value: tabsNames.incomingRequests,
			iconName: 'assetsRequestDark',
			isVisible: isIncomingRequestsTabShown && !isIncomingRequestsEmpty,
		},
		{
			title: tabsNames.outgoingRequests,
			value: tabsNames.outgoingRequests,
			iconName: 'outgoingRequest',
			isVisible: isOutgoingRequestsTabShown,
		},
		{
			title: tabsNames.telecomSites,
			value: tabsNames.telecomSites,
			iconName: 'manageSiteDB',
			isVisible: isTelecomSitesTabShown,
		},
	];
};

export const viewOnMapTooltip = 'View on Map';
export const assetHistoryTooltip = 'Asset history';
